import { render } from "./Aside.vue?vue&type=template&id=71c7ad0d&scoped=true&ts=true"
import script from "./Aside.vue?vue&type=script&lang=ts"
export * from "./Aside.vue?vue&type=script&lang=ts"

import "./Aside.vue?vue&type=style&index=0&id=71c7ad0d&scoped=true&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c7ad0d"]])

export default __exports__